import React, { useEffect, useState } from 'react'
import FlatList from 'flatlist-react'
import Loading from '../Loading/Loading'
import HttpRequest from '../../services/HttpRequest'
import Notify from '../../services/Notify'
import { Row } from 'react-bootstrap'

const httpRequest = new HttpRequest()

function InfinityScrollList({ endpoint, renderItems, pageSize = 10, onData, groupSeparator, groupBy, addParams, emptyListMessage }) {

  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [page, setPage] = useState(0)
  const [size, setsize] = useState(pageSize)
  const [hasMoreItems, setHasMoreItems] = useState(false)

  const loadItems = async () => {
    try {
      setIsLoading(true)

      const { number, totalPages, content } = await httpRequest.get(`${endpoint}?${getParams()}`)

      content.map((x, i) => {
        x.index = i
        return x
      })

      const newData = onData && onData(content) || content

      setData([...data, ...newData])
      setPage(number + 1)
      setHasMoreItems((page !== (totalPages - 1)))
    } catch (error) {
      Notify.error('Erro ao buscar itens', error)
    } finally {
      setIsLoading(false)
    }
  }

  const getParams = () => {
    const params = new URLSearchParams({})

    params.append('size', size)
    params.append('page', page)

    addParams && addParams(params)

    return params
  }

  const renderWhenEmpty = () => {
    return (
      <Row className="justify-content-center w-100 overflow-hidden">
        {data.length === 0 && isLoading ? <Loading /> : <h4>{ emptyListMessage || "A lista está vazia" }</h4>}
      </Row>
    )
  }

  useEffect(() => {
    loadItems()
  }, [])

  useEffect(() => {
    renderItems && renderItems(data)
  }, [data])

  return (
    <FlatList
      list={data}
      renderItem={renderItems}
      renderWhenEmpty={renderWhenEmpty}
      hasMoreItems={hasMoreItems}
      loadMoreItems={() => !isLoading && loadItems()}
      paginationLoadingIndicator={<Loading />}
      paginationLoadingIndicatorPosition="center"
      groupBy={groupBy}
      groupSeparator={content => groupSeparator && groupSeparator(content[0])}
    />
  )
}

export default InfinityScrollList



// WEBPACK FOOTER //
// ./src/component/List/InfinityScrollList.js